import { StoreItem } from '@givebacks/api/store';
import { Stack, Title } from 'ui';

import { DonationAmountGroup } from '../../../donations/components/SimpleDonation/sections/SectionOne/components/DonationAmountGroup';

type DonationAmountFormProps = {
  onChange: ({
    value,
    label,
    maxAmount,
  }: {
    value: number;
    label?: string;
    maxAmount?: number;
  }) => void;
  pricing: StoreItem['default_pledge'] | StoreItem['default_pricing'];
  isPledge?: boolean;
  credits?: string[];
};

const DonationAmountForm = ({
  onChange,
  pricing,
  isPledge = false,
  credits,
}: DonationAmountFormProps) => {
  return (
    <Stack>
      <Stack gap={4}>
        <Title order={4}>{isPledge ? 'Pledge' : 'Donation'} Amount</Title>
      </Stack>
      <DonationAmountGroup onChange={onChange} isPledge={isPledge} pricing={pricing} />
    </Stack>
  );
};

export { DonationAmountForm };
